<template>
  <v-card min-height="150px" :style="{ background: dashboardGradient}">
    <v-container class="px-6">
      <v-row class="pt-4 px-4">
        <inline-svg
          class="mt-2"
          :src="svgSource"
          width="50"
          height="50"
          aria-label="Navigation Icon"
        />
        <v-card-title>
          <span class="text-h4 white--text" v-text="title" />
        </v-card-title>
      </v-row>
      <v-card-actions>
        <v-spacer />
        <template v-for="(button, index) in buttons">
          <v-btn
            v-if="button.show"
            :key="index"
            outlined
            dark
            class="px-6 py-5 text-capitalize"
            :disabled="button.disabled || false"
            @click="button.action"
            v-text="button.label"
            data-qa="role-header-button"
          />
        </template>
      </v-card-actions>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'RoleHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    svgSource: {
      type: String,
      required: true
    },
    buttons: {
      type: Array,
      required: true
    }
  }
}
</script>
